"use strict";
// Copyright (C) 2017-2026 Smart code 203358507
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var react_i18next_1 = require("react-i18next");
var EPG_1 = require("stremio/common/EPG");
var useFormatters = function (now) {
    var _a = (0, react_i18next_1.useTranslation)(), t = _a.t, i18n = _a.i18n;
    return (0, react_1.useMemo)(function () {
        var time = new Intl.DateTimeFormat(i18n.language, { hour: '2-digit', minute: '2-digit' });
        var day = new Intl.DateTimeFormat(i18n.language, { weekday: 'short', day: 'numeric', month: 'short' });
        var minutes = new Intl.NumberFormat(i18n.language, { style: 'unit', unit: 'minute', unitDisplay: 'short' });
        var today = (0, EPG_1.epgDateKey)(new Date(now));
        return {
            time: function (value) { return time.format(value); },
            timeRange: function (program) { return "".concat(time.format(program.startTime), " - ").concat(time.format(program.endTime)); },
            duration: function (program) { return minutes.format(Math.ceil((program.endTime.getTime() - program.startTime.getTime()) / 60000)); },
            dayLabel: function (date) { return (0, EPG_1.epgDateKey)(date) === today ? t('LIVE_TV_TODAY', { defaultValue: 'Today' }) : day.format(date); },
        };
    }, [i18n.language, t, now]);
};
exports.default = useFormatters;
